import { render, staticRenderFns } from "./ConfigurationS3.vue?vue&type=template&id=2ce04134&"
import script from "./ConfigurationS3.vue?vue&type=script&lang=js&"
export * from "./ConfigurationS3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce04134')) {
      api.createRecord('2ce04134', component.options)
    } else {
      api.reload('2ce04134', component.options)
    }
    module.hot.accept("./ConfigurationS3.vue?vue&type=template&id=2ce04134&", function () {
      api.rerender('2ce04134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/S3/ConfigurationS3.vue"
export default component.exports